var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewleads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8.008C4 3.591 7.587 0 12 0s8 3.591 8 8.008c-.017 4.333-3.402 7.84-7.714 7.992H12.168a1.354 1.354 0 0 0-.37 0C7.385 15.848 4 12.341 4 8.008zm-.642 12.406c4.79-3.219 12.545-3.219 17.301 0 2.148 1.454 3.324 3.427 3.341 5.556 0 2.146-1.193 4.119-3.34 5.59C18.272 33.187 15.135 34 12 34s-6.273-.813-8.66-2.44C1.194 30.106 0 28.133 0 26.004c0-2.128 1.193-4.119 3.358-5.59zM30.978 9.49c.272 3.243-2.07 6.084-5.311 6.469H25.582c-.102 0-.204 0-.288.033-1.647.084-3.157-.434-4.294-1.387a7.591 7.591 0 0 0 2.546-6.352 7.683 7.683 0 0 0-1.307-3.644 6.137 6.137 0 0 1 2.155-.585c3.326-.285 6.296 2.156 6.585 5.466zm-.038 19.217c1.818-.944 2.901-2.333 3.04-3.938.158-1.589-.663-3.127-2.271-4.352-2.988-2.283-7.847-2.994-11.709-1.936 1.485.513 2.849 1.208 4.02 2.085 2.062 1.572 3.093 3.54 2.918 5.593-.14 1.422-.874 2.763-2.132 3.838 2.184.05 4.386-.38 6.134-1.29z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 10,
    y1: 6.5,
    x2: 31.745,
    y2: 28.499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3E7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48AFCC"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewleads);
export default __webpack_public_path__ + "static/media/newleads.63469827bee00e69faa62df2b6390663.svg";
export { ForwardRef as ReactComponent };